import React from 'react';
import './ProductCard.scss';

export interface ProductCardSkeletonPropType {}

export const ProductCardSkeleton: React.FC<ProductCardSkeletonPropType> = () => {
    return (
        <div className="product-card product-card--skeleton">
            <div className="product-card__upper-area">
                <div className="product-card__image-box">
                    <div className="product-card__image skeleton-light-color"></div>
                </div>

                <div className="product-card__content">
                    <div className="product-card__titleSkeleton skeleton-light-color"></div>
                    <div className="product-card__priceSkeleton skeleton-light-color"></div>
                </div>
            </div>
        </div>
    );
};
